import { render } from "./ModalTeleportComponent.vue?vue&type=template&id=0299fe2b"
import script from "./ModalTeleportComponent.vue?vue&type=script&lang=js"
export * from "./ModalTeleportComponent.vue?vue&type=script&lang=js"

import exportComponent from "/__w/map-lux/map-lux/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__